import { Component, Input } from '@angular/core';

export type size = 'lg' | 'md' | 'sm';
@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() title = 'No results found';
  @Input() text = '';
  @Input() icon = 'folder-open';
  @Input() iconStyle = 'fas';
  @Input() size: size = 'md';

  iconString = `${this.iconStyle} fa-${this.icon}`;
}
